var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPresentationStep3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 109,
    viewBox: "0 0 111 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 111,
    height: 109,
    rx: 23,
    fill: "#CAE6FD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6789_22571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.5469 78.0986L43.7489 78.0986C43.2978 78.0986 42.8511 78.0019 42.4344 77.8139C42.0177 77.6259 41.6392 77.3503 41.3206 77.003C41.0019 76.6557 40.7494 76.2435 40.5774 75.7899C40.4055 75.3363 40.3175 74.8503 40.3184 74.3596V66.7212C40.3184 65.7535 40.6719 64.8254 41.3011 64.1412C41.9302 63.4569 42.7836 63.0725 43.6733 63.0725L79.5469 63.0725V78.0886V78.0986Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0626 69.2609V71.5204C11.0578 72.6696 11.3049 73.8036 11.7833 74.8283C12.705 76.783 14.4101 78.0982 16.3677 78.0982H80.5994C81.0234 78.0982 81.3681 77.6712 81.3681 77.1439V76.8071C81.3681 76.2798 81.0234 75.8528 80.5994 75.8528H41.4374C41.2232 75.5314 41.038 75.1884 40.8844 74.8283C40.5023 73.9285 40.306 72.9486 40.3092 71.9574V69.0865C40.3089 68.5717 40.3621 68.0586 40.4678 67.5568C40.6357 66.7569 40.9443 65.9999 41.3765 65.3274H80.5994C81.0234 65.3274 81.3681 64.9004 81.3681 64.3731V64.0363C81.3681 63.5091 81.0234 63.082 80.5994 63.082H16.0452C13.7686 63.082 11.8515 64.9726 11.2524 67.5568C11.1249 68.1142 11.0611 68.6865 11.0626 69.2609Z",
    fill: "#219CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5488 70.5898L74.793 70.8425L79.5488 70.9948V70.5898Z",
    fill: "#A8BFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5489 72.9463L68.2344 73.1989L79.5489 73.3513V72.9463Z",
    fill: "#A8BFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.18 46.3779L64.3817 46.3779C63.4719 46.3779 62.5994 45.9848 61.956 45.2851C61.3127 44.5855 60.9512 43.6365 60.9512 42.6469V35.0085C60.9512 34.0408 61.3047 33.1127 61.9339 32.4285C62.563 31.7442 63.4164 31.3598 64.3062 31.3598L100.18 31.3598V46.3759V46.3779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6954 37.5512V39.8107C31.6909 40.9603 31.9373 42.0947 32.4143 43.1206C33.336 45.0753 35.0429 46.3905 37.0006 46.3905H101.23C101.449 46.374 101.652 46.2645 101.796 46.0858C101.941 45.9071 102.014 45.6736 102.001 45.4362V45.0974C102.014 44.8602 101.94 44.6269 101.796 44.4485C101.652 44.2701 101.448 44.1611 101.23 44.1451H62.0831C61.8702 43.8228 61.6851 43.4799 61.5301 43.1206C61.149 42.2205 60.9534 41.2407 60.9568 40.2497V37.3668C60.9565 36.8527 61.0097 36.3402 61.1153 35.8391C61.2823 35.0392 61.5903 34.2821 62.0223 33.6097H101.23C101.449 33.5932 101.652 33.4837 101.796 33.305C101.941 33.1263 102.014 32.8928 102.001 32.6554V32.3186C102.001 31.7913 101.656 31.3623 101.23 31.3623H36.6761C34.4014 31.3623 32.4825 33.2549 31.8834 35.8391C31.7558 36.3991 31.6927 36.9742 31.6954 37.5512Z",
    fill: "#219CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.182 38.8721L95.4258 39.1247L100.182 39.275V38.8721Z",
    fill: "#A8BFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.182 41.2275L88.8672 41.4801L100.182 41.6325V41.2275Z",
    fill: "#A8BFEF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6789_22571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.5078 78.0664H96.2689C96.9465 78.0664 97.5963 78.3592 98.0755 78.8803C98.5546 79.4014 98.8238 80.1081 98.8238 80.8451V86.7874C98.8238 87.5722 98.5371 88.3249 98.0269 88.8798C97.5166 89.4348 96.8246 89.7465 96.103 89.7465H60.5078V78.0664Z",
    fill: "#0054A3"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6789_22571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9609 78.0664H64.2327C64.9245 78.0664 65.5879 78.3653 66.0771 78.8973C66.5662 79.4293 66.8411 80.1509 66.8411 80.9032V86.8435C66.8411 87.6129 66.56 88.3508 66.0598 88.8949C65.5596 89.4389 64.8811 89.7445 64.1737 89.7445H23.9609V78.0664Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M69.6713 88H22.3671C22.1493 88 21.9727 88.1921 21.9727 88.429V89.3172C21.9727 89.5541 22.1493 89.7462 22.3671 89.7462H69.6713C69.8892 89.7462 70.0658 89.5541 70.0658 89.3172V88.429C70.0658 88.1921 69.8892 88 69.6713 88Z",
    fill: "#0054A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6713 78.0664H22.3671C22.1493 78.0664 21.9727 78.2585 21.9727 78.4954V79.3836C21.9727 79.6205 22.1493 79.8126 22.3671 79.8126H69.6713C69.8892 79.8126 70.0658 79.6205 70.0658 79.3836V78.4954C70.0658 78.2585 69.8892 78.0664 69.6713 78.0664Z",
    fill: "#0054A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9609 83.9062L29.1592 84.1027L23.9609 84.221V83.9062Z",
    fill: "#B9CAF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9609 81.2197L36.3298 81.4162L23.9609 81.5345V81.2197Z",
    fill: "#B9CAF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2092 81.2891C50.8626 81.6491 50.6182 82.1097 50.5051 82.6163C50.472 82.7675 50.4535 82.922 50.4498 83.0774C50.4203 84.174 50.4498 86.654 50.4498 86.654L48.8848 85.413L47.3179 86.654V83.2919C47.3005 82.7111 47.4333 82.1366 47.7013 81.6339C47.7425 81.543 47.8032 81.4642 47.8783 81.4042C47.9534 81.3442 48.0406 81.3047 48.1327 81.2891H51.2092Z",
    fill: "#739CE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.209 81.2891C50.8623 81.6491 50.6179 82.1097 50.5048 82.6163L47.3711 82.6644C47.3711 82.6644 47.4946 81.4835 48.1416 81.2891H51.209Z",
    fill: "#618BD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9727 63.1143L49.6401 63.1143C48.6002 63.1143 47.6029 62.665 46.8677 61.8653C46.1324 61.0656 45.7193 59.9809 45.7193 58.85V50.121C45.7193 49.0155 46.123 47.9554 46.8417 47.1737C47.5604 46.3921 48.5352 45.9529 49.5516 45.9529H87.9727V63.1143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7006 52.6114V56.3043C45.7098 57.8821 46.4029 59.2514 47.4242 59.9831C47.9282 60.3483 48.5199 60.5443 49.1256 60.5465H89.0858C89.554 60.5465 89.9338 61.0236 89.9338 61.613V62.0481C89.9338 62.6375 89.554 63.1147 89.0858 63.1147H20.054C18.0724 63.1147 16.3231 61.8777 15.2613 59.9831C14.5623 58.7109 14.1964 57.255 14.2032 55.773V52.8519C14.2022 51.8195 14.3902 50.7973 14.7562 49.8447C15.6447 47.5371 17.5213 45.9453 19.7001 45.9453H89.0858C89.554 45.9453 89.9338 46.4225 89.9338 47.0099V47.4469C89.9338 48.0343 89.554 48.5115 89.0858 48.5115H49.0039C48.5325 48.5205 48.0691 48.645 47.6481 48.8759C47.2271 49.1067 46.8595 49.4379 46.5725 49.8447C46.003 50.6334 45.6957 51.6085 45.7006 52.6114Z",
    fill: "#0054A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9742 54.5332L82.8516 54.8219L87.9742 54.9963V54.5332Z",
    fill: "#B9CAF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9755 50.584L75.7891 50.8727L87.9755 51.0471V50.584Z",
    fill: "#B9CAF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2852 50.8146C49.2852 50.8146 50.0889 51.3599 50.3561 52.254C50.4049 52.4154 50.4328 52.5834 50.4391 52.7532C50.4833 53.9421 50.4391 56.6326 50.4391 56.6326L52.8133 55.2873L55.182 56.6326V52.9878C55.2007 52.3289 54.9938 51.6859 54.6014 51.1834C54.5217 51.0753 54.4222 50.9864 54.3092 50.9222C54.1963 50.858 54.0723 50.82 53.9452 50.8105L49.2852 50.8146Z",
    fill: "#EB9A57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2852 50.8145C49.2852 50.8145 50.0889 51.3598 50.3561 52.2539L55.1138 52.306C55.1138 52.306 54.9295 51.027 53.9452 50.8145H49.2852Z",
    fill: "#DE8140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0646 63.0303L98.5927 65.0973L95.4516 64.6381L94.4175 67.5672L92.0156 67.6434L92.0506 68.9666L95.2636 68.8663L96.2424 66.0896L99.5107 66.5668L100.222 63.4553L99.0646 63.0303Z",
    fill: "#FF724F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9786 18.7446L53.9311 15.9073L51.295 15.286C51.2275 15.2702 51.1653 15.233 51.1153 15.1788C51.0653 15.1245 51.0295 15.0554 51.0121 14.9791C50.9946 14.9028 50.9961 14.8224 51.0165 14.7471C51.0368 14.6717 51.0752 14.6044 51.1272 14.5527L53.1606 12.5336L52.8613 9.47207C52.8532 9.39329 52.8646 9.3135 52.8943 9.24181C52.9239 9.17012 52.9706 9.10943 53.0289 9.06667C53.0873 9.02392 53.155 9.00082 53.2242 9.00002C53.2935 8.99922 53.3616 9.02076 53.4207 9.06216L55.7253 10.6538L58.174 9.3872C58.2368 9.35495 58.3062 9.34335 58.3744 9.35371C58.4426 9.36406 58.507 9.39595 58.5603 9.44582C58.6135 9.49569 58.6537 9.56155 58.6761 9.63604C58.6985 9.71053 58.7024 9.7907 58.6873 9.86756L58.0859 12.8634L59.9039 15.1387C59.9503 15.1972 59.9814 15.2694 59.9939 15.3471C60.0064 15.4248 59.9997 15.5049 59.9745 15.5784C59.9494 15.652 59.9068 15.716 59.8516 15.7634C59.7964 15.8107 59.7307 15.8395 59.662 15.8464L56.9672 16.1122L55.6386 18.7895C55.6041 18.8572 55.5539 18.9127 55.4935 18.9497C55.4331 18.9868 55.3649 19.0039 55.2966 18.9993C55.2282 18.9946 55.1623 18.9684 55.1061 18.9234C55.05 18.8785 55.0058 18.8166 54.9786 18.7446Z",
    fill: "#0074E4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6789_22571",
    x: 56.5078,
    y: 78.0664,
    width: 46.3164,
    height: 19.6797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6789_22571"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6789_22571",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6789_22571",
    x: 19.9609,
    y: 78.0664,
    width: 50.8789,
    height: 19.6777,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6789_22571"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6789_22571",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6789_22571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 98,
    fill: "white",
    transform: "translate(10 9)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentationStep3);
export default __webpack_public_path__ + "static/media/presentation-step3.8c3dbf76aa105b4eb21fcdf80bfcaf59.svg";
export { ForwardRef as ReactComponent };